import { PlusIcon } from '../../icons/PlusIcon';
import { RemoveIcon } from '../../icons/RemoveIcon';
import { StepButton, Value, Wrapper } from './Counter.styles';
import type { CounterProps } from './Counter.types';

export function Counter({
  value,
  min = 0,
  max,
  step = 1,
  onChange,
  decreaseLabel = 'Decrease',
  increaseLabel = 'Increase',
}: CounterProps) {
  const canDecrement = value > min;
  const canIncrement = max === undefined || value < max;

  const handleDecrement = () => {
    onChange(Math.max(min, value - step));
  };

  const handleIncrement = () => {
    if (value < min) {
      onChange(min);
      return;
    }
    onChange(max === undefined ? value + step : Math.min(max, value + step));
  };

  return (
    <Wrapper>
      <StepButton
        type="button"
        aria-label={decreaseLabel}
        disabled={!canDecrement}
        onClick={handleDecrement}
      >
        <RemoveIcon />
      </StepButton>
      <Value aria-live="polite">{value}</Value>
      <StepButton
        type="button"
        aria-label={increaseLabel}
        disabled={!canIncrement}
        onClick={handleIncrement}
      >
        <PlusIcon />
      </StepButton>
    </Wrapper>
  );
}
